import { toast } from "react-toastify";
import WebService from "../../utility/WebService"; // adjust path

type QuillLikeRef = React.RefObject<{
  getEditor: () => {
    getSelection: (focus?: boolean) => { index: number; length: number } | null;
    insertEmbed: (index: number, type: string, value: any) => void;
    setSelection: (index: number, length?: number) => void;
    getLength?: () => number;
  };
}>;

type Options = {
  storage?: string;          // default "EVENTS"
  accept?: string;           // default "image/*"
  fieldName?: string;        // default "file"
  onUploaded?: (url: string) => void; // optional hook
};

export const createQuillImageHandler = (
  editorRef: QuillLikeRef,
  options: Options = {}
) => {
  const {
    storage = "EVENTS",
    accept = "image/*",
    fieldName = "file",
    onUploaded,
  } = options;

  return () => {
    // SSR safety (Next.js)
    if (typeof document === "undefined") return;

    const input = document.createElement("input");
    input.type = "file";
    input.accept = accept;
    input.click();

    input.onchange = async () => {
      const file = input.files?.[0];
      if (!file) return;

      const quillWrapper = editorRef.current;
      if (!quillWrapper?.getEditor) {
        toast.error("Editor not ready");
        return;
      }

      const formData = new FormData();
      formData.append(fieldName, file);
      formData.append("storage", storage);

      try {
        const res: any = await WebService.fileUploadAPI({
          action: "upload",
          body: formData,
        });

        const imageUrl = res?.data?.url;
        if (!imageUrl) {
          toast.error("Image URL not returned");
          return;
        }

        onUploaded?.(imageUrl);

        const editor = quillWrapper.getEditor();

        // If selection is null, insert at end
        const range = editor.getSelection(true);
        const insertAt = range?.index ?? (editor.getLength?.() ? editor.getLength() - 1 : 0);

        editor.insertEmbed(insertAt, "image", imageUrl);
        editor.setSelection(insertAt + 1, 0);
      } catch (e) {
        toast.error("Image upload failed");
      }
    };
  };
};
